{
  "pt": {
    "signature": {
      "actions": {
        "clearSignature": "Assinatura clara",
        "edit": "Editar",
        "request": "Solicitar assinatura",
        "save": "Guardar",
        "sign": "Sinal"
      },
      "labels": {
        "add": "Adicionar",
        "add_customer_signatures": "É necessário adicionar assinaturas de clientes antes de guardar.",
        "add_team_member_signatures": "É necessário adicionar assinaturas para os membros da equipa antes de guardar.",
        "all_customers_signed": "Todos os compradores de casas solicitados já assinaram. Os documentos ainda precisam de ser assinados pelos representantes de {client_name} e a proposta será aprovada assim que os assinarem. Não é necessária mais nenhuma ação da sua parte.",
        "browserNotSupported": "Detectámos que o seu browser móvel poderá não suportar assinaturas electrónicas. Se tiver algum problema, mude de navegador ou de dispositivo ou carregue um documento assinado.",
        "customer_signatories": "Signatários clientes",
        "customers_left_to_sign": "1 cliente precisa de assinar | {customers_left_to_sign} clientes precisam de assinar",
        "customers_required_to_sign": "mais 1 comprador de casa precisa de assinar os documentos. | {customers_left_to_sign} mais compradores de imóveis precisam assinar os documentos.",
        "customers_signed_names": "Os clientes já assinaram: {names}",
        "documents_to_sign": "Documentos a assinar",
        "draw_signature": "Desenhe a sua assinatura abaixo",
        "employee_signatories": "{client_name} signatários",
        "employees_signed_names": "Membros da equipa já assinaram: {names}",
        "empty_signature_warning": "Por favor, desenhe primeiro a sua assinatura.",
        "marked": "Posição da assinatura marcada",
        "next": "Seguinte",
        "no_signature_indicators_warning": "Indicar onde o documento deve ser assinado, clicando na(s) página(s).",
        "ok": "OK",
        "original": "Original",
        "page": "página",
        "place_signature_subtitle": "Clique na(s) página(s) onde pretende que o cliente assine eletronicamente",
        "place_signature_title": "Marcar onde assinar",
        "read_and_sign": "Li e desejo assinar",
        "read_documents": "Leia os seguintes documentos antes de os assinar",
        "remove": "Remover",
        "requesting_signage": "Pedido de sinalização de",
        "sign": "Sinal",
        "signatories_for_all_documents": "O número de signatários aplica-se a todos os documentos. Se o alterar, todas as assinaturas serão removidas e terá de as adicionar novamente.",
        "signatureNotPossible": "As assinaturas electrónicas não estão disponíveis para este tipo de ficheiro",
        "signatures_pending_from_client": "Assinaturas pendentes da equipa {client_name} ",
        "signed": "Assinado",
        "signed_progress": "Assinado: {already_signed_count} a partir de {all_required_to_sign_count}",
        "specifyWhereToSign": "Marcar onde assinar",
        "team_member": "Membro da equipa",
        "team_member_signature_warning": "Poderá solicitar sinalização aos membros da equipa depois de ter solicitado sinalização aos clientes.",
        "thank_you_for_signing": "Obrigado por assinar.",
        "toBeSigned": "A assinar"
      }
    }
  }
}